// Import translation
import i18n from 'i18next';

export const eventsLiveTranslationValidate = ({ title, summary_long }) => {
	const errors = {};

	// ------------------ Title ------------------
	if (!title) {
		errors.title = i18n.t('events_live:validation.title');
	} else if (title.length < 2 || title.length > 200) {
		errors.title = i18n.t('articles:validation.title_length');
	}
	// ------------------ summary_long ------------------
	if (!summary_long) {
		errors.summary_long = i18n.t('events_live:validation.summary_long');
	}
	return errors;
};
